import * as React from 'react';

import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';

import { IState } from '../reducers/index';
import theme from '../theme';
import IUser from '../types/models/IUser';
import {
    event,
    EventCategories,
    EventActions,
    EventLabels,
} from '../utils/metric';
import { isServer } from '../../store';
import { openModal } from '../actions/modal';
import NavbarBottomMobile from '../components/navbar/NavbarBottomMobile';

interface IPropsFromState {
    user?: IUser;
    currentPath: string;
}

interface IPropsFromDispatch {
    openModal: typeof openModal;
}

interface IInnerState {
    width: number;
}

class MobileBottomNav extends React.Component<IPropsFromState & IPropsFromDispatch & RouteComponentProps, IInnerState> {
    constructor(props) {
        super(props);

        this.state = { width: 0 };
    }

    public componentDidMount = () => {
        if (!isServer) {
            this.updateWidth();
            window.addEventListener('resize', this.updateWidth);
        }
    };

    public UNSAFE_componentWillReceiveProps = () => {
        if (!isServer) {
            this.updateWidth();
        }
    };

    public isSmallWidth = () => {
        const { width } = this.state;

        if (width === 0) {
            return false;
        }

        return width <= theme.breakpoints.small;
    };

    public updateWidth = () => {
        this.setState({ width: window.innerWidth });
    };

    public onClickHome = () => {
        event(EventCategories.OTHER, EventActions.TAP, EventLabels.HOME);
    };

    public onClickLatest = () => {
        event(EventCategories.OTHER, EventActions.TAP, EventLabels.LATEST);
    };

    public onClickSearch = () => {
        event(EventCategories.OTHER, EventActions.TAP, EventLabels.SEARCH);
    };

    public onClickLibrary = () => {
        event(EventCategories.OTHER, EventActions.TAP, EventLabels.LIBRARY);
    };

    public onClickSettings = () => {
        event(EventCategories.OTHER, EventActions.TAP, EventLabels.SETTINGS);
    };

    public onClickSignup = () => {
        event(EventCategories.OTHER, EventActions.TAP, EventLabels.SIGNUP);
    };

    public render() {
        const { user } = this.props;

        if (!this.isSmallWidth()) {
            return null;
        }

        return (
            <NavbarBottomMobile
                user={user}
                pathname={this.props.location.pathname}
                onClickHome={this.onClickHome}
                onClickLatest={this.onClickLatest}
                onClickSearch={this.onClickSearch}
                onClickLibrary={this.onClickLibrary}
                onClickSettings={this.onClickSettings}
                onClickSignup={this.onClickSignup}
            />
        );
    }
}

function mapStateToProps(state: IState): IPropsFromState {
    const currentPath = !isServer ? window.location.pathname : '';

    return {
        user: state.user.user,
        currentPath,
    };
}

function mapDispatchToProps(dispatch: Dispatch): IPropsFromDispatch {
    return bindActionCreators({ openModal }, dispatch);
}

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(MobileBottomNav),
);
